export const MULTI_PROMPT_TEMPLATE_STEP = {
  settings: 'settings',
  review: 'review',
};

export const MULTI_PROMPT_TEMPLATE_STEP_PROPS = {
  [MULTI_PROMPT_TEMPLATE_STEP.settings]: {
    label: 'Brief',
    submitButtonLabel: 'Brief',
  },
  [MULTI_PROMPT_TEMPLATE_STEP.review]: {
    label: 'Review prompts',
    submitButtonLabel: 'Generate',
  },
};

export const MULTI_PROMPT_TEMPLATE_STEPS = Object.values(MULTI_PROMPT_TEMPLATE_STEP);

export const getStepIndex = (activeStep) =>
  MULTI_PROMPT_TEMPLATE_STEPS.findIndex((step) => step === activeStep);

export const getStepSubmitButtonLabel = (step) =>
  MULTI_PROMPT_TEMPLATE_STEP_PROPS[step].submitButtonLabel;

export const getStepLabel = (index) => Object.values(MULTI_PROMPT_TEMPLATE_STEP_PROPS)[index].label;
